var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftGradientBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-548.234 -797.53 1675.18 2592.232",
    width: 1675.18,
    height: 2592.232,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8180_214617",
    x: -588.234,
    y: -833.53,
    width: 1755.18,
    height: 2672.23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0784314 0 0 0 0 0.301961 0 0 0 0 0.870588 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8180_214617"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8180_214617",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8180_214617",
    x1: -569.444,
    y1: 1292.06,
    x2: 1512.57,
    y2: 499.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#144DDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8180_214617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1069.11 -346.416C889.725 297.391 705.569 683.78 1080.25 1470.69C1454.93 2257.6 -548.234 1363.74 -548.234 1363.74L-148.902 -755.972C-148.902 -755.972 1248.5 -990.223 1069.11 -346.416Z",
    fill: "url(#paint0_linear_8180_214617)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftGradientBlob);
export default __webpack_public_path__ + "static/media/Left_Gradient_Blob.3436b2f88f411d27c526723b2440dfec.svg";
export { ForwardRef as ReactComponent };